import { useServicesQuery } from '@/services/api';
import type { ServicesApiEnvHealthResponse, ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE, WORKSPACE_HEALTH_REFETCH_INTERVAL_IDLE } from '../constants';

/**
 * Fetches workspace health with adaptive polling.
 *
 * Polls every 2 min when the user is on the health page or when the
 * workspace is not healthy (so the nav-bar widget picks up recovery
 * quickly). Falls back to 5 min otherwise.
 */
export function useEnvHealth(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
  active = false,
) {
  return useServicesQuery(
    'getEnvHealth',
    { params: { environment_id: workspaceId }, query: { simulate } },
    {
      refetchInterval: active
        ? WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE
        : (query: { state: { data?: ServicesApiEnvHealthResponse } }) => {
            const isHealthy = (query.state.data?.health ?? 'healthy') === 'healthy';
            return isHealthy ? WORKSPACE_HEALTH_REFETCH_INTERVAL_IDLE : WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE;
          },
      enabled: workspaceId > 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: 'always',
    },
  );
}
